export default [
	{
		path: "/unions/login",
		name: "unionslogin",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/login/index.vue"),
		meta: {
			title: "登录",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/home",
		name: "unionshome",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/home/index.vue"),
		meta: {
			title: "首页",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/form",
		name: "unionsform",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/form/index.vue"),
		meta: {
			title: "申请表单",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/list",
		name: "unionslist",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/form/list.vue"),
		meta: {
			title: "申请列表",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/text",
		name: "unionstext",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/text/index.vue"),
		meta: {
			title: "驿站运营承诺书",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/detail1",
		name: "unionsdetail1",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/form/refuse.vue"),
		meta: {
			title: "驿站详情",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/detail2",
		name: "unionsdetail2",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/form/adopt.vue"),
		meta: {
			title: "驿站详情",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/data",
		name: "unionsdata",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/ziliao/index.vue"),
		meta: {
			title: "资料查阅",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/rank/:type/:id/:sports_item_id?",
		name: "unionsrank",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/rank/index.vue"),
		meta: {
			title: "排行榜",
			showloading: true,
			requiresAuth: false
		}
	},{
		path: "/unions/personalrank/:type/:id/:sports_item_id?",
		name: "unionspersonalrank",
		component: () => import( /* webpackChunkName: "activity" */ "../views/Unions/rank/personal.vue"),
		meta: {
			title: "排行榜",
			showloading: true,
			requiresAuth: false
		}
	},

]